module.exports = __webpack_public_path__ + "Symbolicons_86167.ttf";


//////////////////
// WEBPACK FOOTER
// ./Content/homeaway-bootstrap-3/release/webfonts/Symbolicons.ttf
// module id = 37
// module chunks = 0